<template>
<!-- home v2 -->
  <div class="home">
    <template v-if="pageLayoutData">

      <div class="mis-promo container text-center rel">
        <div>
          <h2
            ref="title"
            class="text-center hp-title"
            :class="[
              animateLogo || dirtyHome ? 'logo-in' : '',
              logoMove || dirtyHome ? 'logo-move' : '',
              logoReady || dirtyHome ? 'logo-ready' : '',
              animateLetters || dirtyHome ? 'next' : ''
            ]"
          >
            <logo
              class="with-slogan"
              animate
              @animation-end="logoTransitionEnd"
            />
            <span
              :class="[
                'slogan-box',
                'font-rg',
                'pl-s',
                'ml-s',
                animateLetters || dirtyHome ? 'animate' : ''
              ]"
              @transitionend="sloganTransitionEnd"
              id="logo-slogan"
              >MAKE IT SIMPLE</span
            >
          </h2>
          <h3
            :class="[
              'logo-extra',
              sloganReady || dirtyHome ? 'show' : '',
              'text-center',
              'text-gray-6'
            ]"
            v-text="localize('hp_our_mission')"
          ></h3>
        </div>
      </div>

      <!-- HP 3 Boxes row-->
      <div class="px-2xl pt-l">
        <div class="rowBoxes" @click="openBoxes()">
            <hp-box :midBoxesW="midboxWidth" :delayClass="delay1" :index="0"></hp-box>
            <hp-box :midBoxesW="midboxWidth" :delayClass="delay2" :index="1"></hp-box>
            <hp-box :midBoxesW="midboxWidth" :delayClass="delay3" :index="2"></hp-box>
        </div>
      </div>

      <div class="px-2xl pt-3xl">
        <div class="rowBanner"></div>
      </div>

      <br/><br/><br/><br/>

    </template>
    <preloader v-else></preloader>
  </div>
</template>

<style scoped>
  .rowBoxes 
  {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }



  .rowBanner
  {
    background: #074a6f;
    height: 60vh;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-image: url('https://vumbnail.com/228635702.jpg');
  }


</style>


<script>
import { mapActions, mapState } from "vuex";
import hpBox from './hp/hpBox.vue';
//import hpBox from "@/views/hp/hpBox.vue";

// @ is an alias to /src
export default {
  components: { hpBox },
  name: "home",
  data() {
    return {
      midBoxesW:400,
      slider: null,
      boxes: null,
      code: "",
      logoReady: false,
      logoMove: false,
      animateLogo: false,
      sloganReady: false,
      animateLetters: false,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      observed: null
    };
  },
  watch: {
    pageLayoutData() {
      // console.log("PAGE DATA IS HERE: ", this.pageLayoutData);
      this.setPageReady(true);
    },
    locale: {
      deep: true,
      handler() {
        // console.log("HOMEPAGE LOCALE CHANGED >> ", this.locale);
        this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);
      }
    },
    logoReady() {
      /*
        Logo finished intro animating
      */
      this.$nextTick(function() {
        let slogan = document.getElementById("logo-slogan");
        slogan.innerHTML = slogan.textContent.replace(
          /\S/g,
          "<span class='scatter letter'>$&</span>"
        );
        setTimeout(
          function() {
            this.animateLetters = true;
          }.bind(this),
          0
        );
      });
    }
  },
  created() {
    this.setPageReady(false);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler, false);
  },
  async mounted() {
    // console.log("homepage mounted...", this.$defaultLang);
    //var element = document.getElementById('cbox1');
    //var positionInfo = element.getBoundingClientRect();
    //var bw = positionInfo.width;

    this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);
    window.addEventListener("resize", this.resizeHandler, false);

    this.animateLogo = false;
    setTimeout(
      function() {
        this.animateLogo = true;
        // setTimeout(
        //   function() {
        //       this.logoMove = true;
        //   }.bind(this),
        //   3000
        // );
        this.$nextTick(function() {
          this.initResizeElements();
        });
      }.bind(this),
      1600
    );
  },
  methods: {
    ...mapActions(["initRouteByPath", "setPageReady", "dirtifyHome"]),
    openBoxes()
    {
      const childCollect = document.getElementsByClassName("hpBoxchild");
      for (let i = 0; i < childCollect.length; i++) {
        childCollect[i].classList.add("childOpen");
      }

      const collection = document.getElementsByClassName("hpBoxBgMask");
      for (let i = 0; i < collection.length; i++) 
      {
        collection[i].style.width = "100%";
        collection[i].classList.add("maskOpen");
      }
    },
    logoTransitionEnd(e) {
      // console.log("transition ended... ", e);
      if (e.propertyName === "fill") {
        this.logoMove = true;
      } else if (e.propertyName === "left") {
        this.logoReady = true;
      }
    },
    sloganTransitionEnd: _.debounce(
      function() {
        // console.log("Slogan transition ended...");
        setTimeout(
          function() {
            this.sloganReady = true;
            this.dirtifyHome(true);
          }.bind(this),
          300
        );
      },
      600,
      { leading: true }
    ),
    resizeHandler: _.debounce(function() 
    {
      let vm = this;      
      var element = document.getElementById('hpBox1');
      var positionInfo = element.getBoundingClientRect();
      vm.midBoxesW = positionInfo.width;      

      if (!this.observed || !this.observed.length) {
        this.observed = document.querySelectorAll("[observe-resize]");
        this.elementSizes.length = this.observed.length;
      }
      // console.log("resize handler", this.observed);
      this.observed.forEach(function(el, index) {
        vm.elementResizeHandler(el, index);
      });
      // this.triggerResize();

    }, 300),
    initResizeElements() {
      this.observed = document.querySelectorAll("[observe-resize]");
      this.elementSizes.length = this.observed.length;
      this.resizeHandler();
    },
    elementResizeHandler(el) {
      if (el) {
        let index = index || el.getAttribute("observe-resize"),
          width = el.offsetWidth;
        if (width > 1200) {
          this.$set(this.elementSizes, index, "large");
        } else if (width > 815) {
          this.$set(this.elementSizes, index, "medium");
        } else {
          this.$set(this.elementSizes, index, "small");
        }
      }
    }
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
    midboxWidth()
    {
      return this.midBoxesW;
    },
    hpSlider() {
      let layout = this.pageLayoutData;
      console.log("layout > ", layout);
      if (layout) {
        return layout.children.find(item => item.type === "slider");
      }
      return null;
    },
    hpBoxes() {
      let layout = this.pageLayoutData;
      if (layout) {
        return layout.children.find(item => item.type === "hp-boxes");
      }
      return null;
    }
  }
};
</script>
<style lang="stylus" scoped>
.fade-from-top
  &-enter-active
  &-leave-active
    transition opacity 2s ease-out, transform 2s ease-out-cubic
  &-enter
  &-leave-to
    transform translateY(-50%) !important
  &-enter-to
  &-leave
    opacity 1 !important
    transform translateY(0) !important
.home
  position relative
  top 33px
  min-height 120vh
  .mis-promo
    // padding 60px 0
    // +below(768px)
    padding 44px 0
    +below(415px)
      _flex(row, wrap, center, center)
      padding 30px 0
  h2
    height 100%
    min-height 70px
    min-width 34vw
    position relative
    _flex(row, nowrap, baseline, center, true)
    +below(1100px)
      _flex(row, nowrap, flex-bottom, center, true)
      min-height auto
    .slogan-box
      color blue_primary
      border-left 1px solid blue_primary
      background #fff
      font-size responsive 27px 52px
      font-weight 500
      opacity 0
      overflow hidden
      & >>> .letter
        opacity 0
        display inline-block
        transform translateY(100%)
        position relative
        font-weight 300 !important
    &.logo-move
      .mis-logo
        left 0
        transform translateX(0)
    &.logo-ready
      .slogan-box.animate
        opacity 1
        & >>> .letter
          opacity 1
          transform translateY(0)
    &.next
      .mis-logo
        position static
        +below(1100px)
          height auto
        +below(415px)
          height 27px
  h3
    font-size responsive 14px 28px
    color gray_8
    &.logo-extra
      opacity 0
      transform translateY(-50%)
      transition opacity 0.4s ease-out, transform 0.4s ease-out
      &.show
        opacity 1
        transform translateY(0)
</style>
